import React from "react";
import wp1600 from "../assets/img/wallpapers/FLR_Wallpaper01_1600x1200.jpg";
import wp2560 from "../assets/img/wallpapers/FLR_Wallpaper01_2560x1600.jpg";
import wp3840 from "../assets/img/wallpapers/FLR_Wallpaper01_3840x2160.jpg";
import wpMobile from "../assets/img/wallpapers/FLR_Wallpaper01_Mobile.jpg";

import wp16002 from "../assets/img/wallpapers/FLR_Wallpaper02_1600x1200.jpg";
import wp25602 from "../assets/img/wallpapers/FLR_Wallpaper02_2560x1600.jpg";
import wp38402 from "../assets/img/wallpapers/FLR_Wallpaper02_3840x2160.jpg";
import wpMobile2 from "../assets/img/wallpapers/FLR_Wallpaper02_Mobile.jpg";

export const Wallpapers = () => {
  return (
    <div id="wallpapers" className="flex start">
      <h2 className="font1 catch" style={{ color: "white" }} id="screenshots">
        Wallpapers
      </h2>
      <div className="flex row wrap">
        <div className="wallpaper-box flex start">
          <img src={wp1600} alt="" />
          <h3 className="font1">Download</h3>
          <div className="wp-options">
            <div className="flex row">
              <a
                className="sub"
                href={wp1600}
                download="FLR_Wallpaper01_1600x1200.jpg"
              >
                1600x1200
              </a>
              <a
                className="sub"
                href={wp2560}
                download="FLR_Wallpaper01_2560x1600.jpg"
              >
                2560x1600
              </a>
            </div>
            <div className="flex row">
              <a
                className="sub"
                href={wp3840}
                download="FLR_Wallpaper01_3840x2160.jpg"
              >
                3840x2160
              </a>
              <a
                className="sub"
                href={wpMobile}
                download="FLR_Wallpaper01_Mobile.jpg"
              >
                Mobile
              </a>
            </div>
          </div>
        </div>
        <div className="wallpaper-box flex start">
          <img src={wp16002} alt="" />
          <h3 className="font1">Download</h3>
          <div className="wp-options">
            <div className="flex row">
              <a
                className="sub"
                href={wp16002}
                download="FLR_Wallpaper02_1600x1200.jpg"
              >
                1600x1200
              </a>
              <a
                className="sub"
                href={wp25602}
                download="FLR_Wallpaper02_2560x1600.jpg"
              >
                2560x1600
              </a>
            </div>
            <div className="flex row">
              <a
                className="sub"
                href={wp38402}
                download="FLR_Wallpaper02_3840x2160.jpg"
              >
                3840x2160
              </a>
              <a
                className="sub"
                href={wpMobile2}
                download="FLR_Wallpaper02_Mobile.jpg"
              >
                Mobile
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
